var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import Vue from 'vue';
import Component from 'vue-class-component';
import PnrValidationForm from 'components/Payment/Forms/PnrValidationForm.vue';
import BookingCancelationForm from 'components/Payment/Forms/BookingCancelationForm.vue';
import PaymentFormDescription from 'components/Payment/Forms/PaymentFormDescription.vue';
var BookingCancelation = /** @class */ (function (_super) {
    __extends(BookingCancelation, _super);
    function BookingCancelation() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.bookingFormType = BookingFormType;
        _this.activeForm = BookingFormType.Validation;
        _this.bookingRef = '';
        return _this;
    }
    BookingCancelation.prototype.mounted = function () {
        window.scrollTo({ top: 0 });
    };
    BookingCancelation.prototype.showCancelationForm = function (bookingRef) {
        if (!bookingRef) {
            return;
        }
        this.bookingRef = bookingRef;
        this.activeForm = BookingFormType.Cancelation;
    };
    BookingCancelation = __decorate([
        Component({
            components: {
                PnrValidationForm: PnrValidationForm,
                BookingCancelationForm: BookingCancelationForm,
                PaymentFormDescription: PaymentFormDescription
            }
        })
    ], BookingCancelation);
    return BookingCancelation;
}(Vue));
export default BookingCancelation;
var BookingFormType;
(function (BookingFormType) {
    BookingFormType[BookingFormType["Validation"] = 0] = "Validation";
    BookingFormType[BookingFormType["Cancelation"] = 1] = "Cancelation";
})(BookingFormType || (BookingFormType = {}));
